<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M957 390.9V228.7H511.1L430 147.6H65.1v121.6h0.1v121.6h-0.1v486.5h892l-0.1-486.4zM105.7 228.7v-40.5h307.6l69.2 69.2 11.9 11.9h422.2v121.6H105.7V228.7z m810.8 608.2H105.7V431.4h810.9v405.5z"
    />
  </svg>
</template>
